import { getAssignmentActivityList } from "../../../redux/actions/assignmentAction";
import { getConfigurationData } from "../../../redux/actions/configurationAction";
import { getDeptWithUserAndCollaborators } from "../../../redux/actions/department";

export const getWorkflowList = (dispatch, company_id) => {
  const request = {
    company_id: company_id,
    onError: () => {},
  };
  dispatch(getConfigurationData(request));
};

export const getToDoList = (dispatch, company_id) => {
  const request = {
    company_id: company_id,
    onSuccess: () => {},
    onError: () => {},
  };
  dispatch(getAssignmentActivityList(request));
};

export const getDeptUserAndCollaborator = (dispatch, company_id) => {
  const request = {
    company_id: company_id,
    onSuccess: () => {},
    onError: () => {},
  };
  dispatch(getDeptWithUserAndCollaborators(request));
};

export const statusOuterColor = (status) => {
  switch (status) {
    case "pending": {
      return "border-[--bg-color-500]";
    }

    case "completed": {
      return "border-[--bg-color-500]";
    }
    case "completed with delay": {
      return "border-[--bg-color-500]";
    }

    case "in progress": {
      return "border-[--bg-color-500]";
    }

    case "overdue": {
      return "border-[#D31313]";
    }

    case "overdue-inprogress": {
      return "border-[#D31313]";
    }

    case "overdue-completed": {
      return "border-[#D31313]";
    }

    case "tentative": {
      return "border-[--bg-color-500] border-dotted";
    }

    default:
      break;
  }
};


export const status_fill_Color1 = (status, isSelected) => {
  switch (status) {
    case "pending": {
      return "";
    }

    case "completed": {
      return isSelected ? "bg-white" : "bg-[--bg-color-500]";
    }

    case "completed with delay": {
      return isSelected ? "bg-white" : "bg-[--bg-color-500]";
    }

    case "in progress": {
      return isSelected ? "bg-white" : "bg-[--bg-color-500]";
    }

    case "overdue": {
      return "";
    }

    case "overdue-inprogress": {
      return isSelected ? "ba-white" : "bg-[#D31313]";
    }

    case "overdue-completed": {
      return isSelected ? "ba-white" : "bg-[#D31313]";
    }

    default:
      break;
  }
};

export const status_fill_Color2 = (status, isSelected) => {
  switch (status) {
    case "pending": {
      return "";
    }

    case "completed": {
      return isSelected ? "bg-white" : "bg-[--bg-color-500]";
    }

    case "completed with delay": {
      return isSelected ? "bg-white" : "bg-[--bg-color-500]";
    }

    case "in progress": {
      return "";
    }

    case "overdue": {
      return "";
    }

    case "overdue-inprogress": {
      return "";
    }

    case "overdue-completed": {
      return isSelected ? "bg-white" : "bg-[#D31313]";
    }

    default:
      break;
  }
};
